import {Button, Dropdown, MenuProps, message, Modal, Tooltip} from "antd";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {StyledContainer} from "./styled";
import RenameModal from "../RenameModal";
import {useSize} from "ahooks";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
    EVENT_DELETE_ELEMENT,
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_DELETE_PDF_FROM_DIALOG,
    EVENT_ISFULL_SCREEN,
    EVENT_ORIGIN_KEY,
    EVENT_PDF_ON_SLIDER_RIGHT,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_PDF_HIGHLIGHT,
    EVENT_RENAME_LIBRARY_ITEM,
    SYS_CONFIG_KEY_THEME,
    THEME_LIGHT
} from "@/Const";
import {t} from "i18next";
import {createCopyLink, getImagePathWithTheme, imgPathPerfix, isDarkMode, isInDraw, isInPageTag} from "@/utils";
import TitleBar from "@/TitleBar";
import {getCardById, renameCard, updateCard} from "@model/card";
import {createBreadcrumb, getPdfPath, getTheme} from "@/Utility";
import {
    IconAddToProject,
    IconCopyLink,
    IconDelete,
    IconInfoMenu,
    IconManagerTags,
    IconMenuExportItem,
    IconRename, IconSearch,
    IconViewAllHighlight
} from "@/Icon";
import Draggable, {DraggableData, DraggableEvent} from 'react-draggable';
import global from "@/global";
import {KEYS} from "../../../../../@excalidraw/packages/excalidraw/keys";
import {atom, useAtom} from "jotai";
import {atomCardItemPointerEvent} from "@/views/Home/HomeIndex";
import {getLanguageCode} from "@/language";
import {debugLog} from "@/LogUtils";
import {file} from "../../../../../@excalidraw/packages/excalidraw/components/icons";

interface Props {
    open: boolean;
    fileName: string;
    fileId: string;
    filePath: string;
    isFullScreen?:boolean;
    isViewAllHighlight?:boolean;
    onClose: (isUpdate?: boolean) => void;
    isShowMoreMenu?:boolean;
    highlightId?:string;
    zIndex?:number,
    initialPage?:number,
    state?:any,
    maskLayer?:boolean;
}

const getItems  =()=>{
    return [
        {
            key: '2',
            label: t("Export as Pdf"),
            icon:<IconMenuExportItem/>
        },
        {
            key: 'sep_0',
            type:'divider'
        },
        {
            key: '1',
            label: t("Rename"),
            icon:<IconRename/>
        },
        {
            key: 'search',
            label: t("Search"),
            icon:<IconSearch/>
        },
        {
            key: 'viewAllHighlights',
            label: t("View all highlights"),
            icon:<IconViewAllHighlight/>
        },
        // {
        //     key: '4',
        //     label: t("Copy link"),
        //     icon:<IconCopyLink/>
        // },
        {
            key: 'showInfo',
            label: t("Show info"),
            icon:<IconInfoMenu/>
        },
        {
            key: 'sep_1',
            type:'divider'
        },
        {
            key: 'copyLink',
            label:t('Copy link'),
            icon:<IconCopyLink/>
        },
        {
            key: 'managerTags',
            label:t('Manage tags'),
            icon:<IconManagerTags/>
        },
        {
            key: 'addToProject',
            label:t('Add to project'),
            icon:<IconAddToProject/>
        },
        {
            key: 'sep_2',
            type:'divider'
        },
        {
            key: 'delete',
            label: t("Delete"),
            icon:<IconDelete/>
        },
    ]
}

//这个要控制所有的pdf dialog
export const atomPointerEvents = atom<string>('all');

const FileModal = forwardRef((props:{open:any, fileName:any, fileId:any, filePath:any,isFullScreen:any,isViewAllHighlight:any, onClose:any,isShowMoreMenu:any,highlightId:any,zIndex:any,maskLayer:any,initialPage:any,state:any}, ref) => {
    useImperativeHandle(ref,()=>({
        getIsPin:getIsPin,
        getData:getData,
        showOrHidden:showOrHidden
    }))
    const {open, fileName, fileId, filePath,isFullScreen,isViewAllHighlight, onClose,isShowMoreMenu,highlightId,zIndex,initialPage,state} = props;
    const [fullscreen, setFullscreen] = useState(props.isFullScreen); // 是否撑满应用预览pdf
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [updateName, setUpdateName] = useState(props.fileName)
    const [renameState, setReNameState] = useState({
        open: false
    })
    const [messageApi, contextHolder] = message.useMessage();
    const [isUpdate, setIsUpdate] = useState(false);
    const size = useSize(document.getElementById("root"));

    const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
    const draggleRef = useRef<HTMLDivElement>(null!);
    const dragTransform = useRef<any>('translate(0px, 0px)');
    const [isPin,setIsPin] = useState(false);

    const [isVisible,setIsVisible] = useState(true);

    //拖拽
    const mIsDragging = useRef<any>(false);
    const offset = useRef<any>({x:0,y:0});

    const nWidth = document.body.clientWidth*0.8;
    const nHeight = document.body.clientHeight*0.85;
    const mResizing = useRef(null);
    const [x, setX] = useState((document.body.clientWidth-nWidth)*0.5); // div 的左上角 x 坐标
    const [y, setY] = useState((document.body.clientHeight - nHeight)*0.5); // div 的左上角 y 坐标
    // const [resizing, setResizing] = useState(null); // 当前正在拖拽的角

    const initialMousePos = useRef<any>({ x: 0, y: 0});
    const [dialogSize,setDialogSize] = useState<any>({width:nWidth,height:nHeight});

    const [hasMaskLayer,setHasMaskLayer] = useState(window.getDialogPinCount() == 0);

    // const [pointerEvents,setPointerEvents] = useState('all');
    const [pointerEvents,setPointerEvents] = useAtom(atomPointerEvents);
    const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);

    const mFileIdRef = useRef<any>('');

    useEffect(() => {
        if (props.open && props.fileName) {
            setUpdateName(props.fileName)
        }
        setHasMaskLayer(window.getDialogPinCount() == 0);

        window.refreshList['updatePdfAnnoComment_'+props.fileId] = ()=>{
            iframeRef.current?.contentWindow?.postMessage(JSON.stringify({
                fileId: props.fileId,
                type: "refresh-annotations"
            }), {
                targetOrigin: '*'
            })
        }
        return ()=>{
            delete window.refreshList['updatePdfAnnoComment_'+props.fileId];
        }
    }, [open, props.fileName])

    useEffect(() => {
        setFullscreen(props.isFullScreen)
    }, [props.isFullScreen]);

    useEffect(() => {
        if (isPin){
            if (global.g_isHiddenAllFloatWin){
                //有隐藏的
                window.visibleAllFloatWin();
            }
        }
    }, [isPin]);

    useEffect(() => {
        // window.IPC.on("download-pdf-callback", (_, data: any) => {
        //     messageApi.destroy("export-loading")
        //     if (data?.isSuccess) {
        //         messageApi.success("导出成功，请到下载目录中查看!")
        //     } else {
        //         messageApi.error("导出失败!")
        //     }
        // })
        // document.addEventListener('ready',(event)=>{
        //     alert('ok')
        // })

        //这个，和下面那个同样的都要保留。不然不会滚动到....
        if (props.highlightId){
            setTimeout(()=>{
                iframeRef.current?.contentWindow?.postMessage(JSON.stringify({
                    type: 'highlights-location',
                    id: props.highlightId,
                    time: 1000
                }))
            },1500)
        }
    }, [props.highlightId])

    useEffect(()=>{
        // document.body.addEventListener('mousemove',handleMouseMove);
        // document.body.addEventListener('mouseup',handleMouseUp);
        // return () => {
        //     // document.body.removeEventListener('mousedown',onMouseLeftButtonDown);
        //     document.body.removeEventListener('mousemove',handleMouseMove);
        //     document.body.removeEventListener('mouseup',handleMouseUp);
        // }
        mFileIdRef.current = fileId;
        if (global.g_isCtrlPressed){
            setIsPin(true);
            setHasMaskLayer(false);
            //宽度小一半
            setDialogSize({width:nWidth*0.5,height:nHeight});
            setX((document.body.clientWidth - nWidth*0.5)*0.5);
        }

        document.body.addEventListener('mousemove',handleMouseMove);
        document.body.addEventListener('mouseup',handleMouseUp);
        document.body.addEventListener('keydown',onKeydown);

        //这个在drawindex中有初始化使用。这里不能用....不要了....
        // global.g_showDialogs['dialogPdf'] = true;

        return ()=>{
            document.body.removeEventListener('mousemove',handleMouseMove);
            document.body.removeEventListener('mouseup',handleMouseUp);
            document.body.removeEventListener('keydown',onKeydown);
            // global.g_showDialogs['dialogPdf'] = false;
            //刷新
            if (isInPageTag()){
                window.globalRefreshList('refresh_tableview_single_data_',fileId);
            }
        }
    },[])

    useEffect(() => {
        recvMessage(EVENT_ORIGIN_KEY,(msg,data)=>{
            if (data.data.key == KEYS.ESCAPE){
                if (fullscreen){
                    setFullscreen(false);
                    onFullScreenByWeb(false);
                }else{
                    // 取消keys.escape
                    if (!isPin){
                        onCloseForPerson(true);
                    }
                }
            }
        })

        recvMessage(EVENT_ISFULL_SCREEN,(msg,data)=>{
            if (!data.data.isFullScreen){
                setFullscreen(false);
                onFullScreenByWeb(false);
            }
        })

        window.exitFullScreen = ()=>{
            if (fullscreen){
                onFullScreenByWeb(false);
            }
        }

        return ()=>{
            unSubscribe(EVENT_ORIGIN_KEY);
            delete window.exitFullScreen
        }
    }, [fullscreen,isPin]);

    function onKeydown(event:any){
        // debugLog('actionProperties',event);
        if ((event.metaKey || event.ctrlKey) && event.key == KEYS.F){
            //打开搜索
            onClickMenu({key:'search'});
        }
    }

    /**
     * 直接WEB端的全屏...不通过客户端
     */
    const onFullScreenByWeb = (bIsFullScreen: boolean) => {
        if (bIsFullScreen) {
            var ele = document.body;
            if (ele.requestFullscreen) {
                ele.requestFullscreen();
            } else if (ele.mozRequestFullScreen) {
                ele.mozRequestFullScreen();
            } else if (ele.webkitRequestFullscreen) {
                ele.webkitRequestFullscreen();
            } else if (ele.msRequestFullscreen) {
                ele.msRequestFullscreen();
            }
        } else {
            if (document.exitFullScreen) {
                document.exitFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }


    // const getWidth = ()=>{
    //     if (fullscreen){
    //         return size?.width || 0;
    //     }
    //     return (document.body.clientWidth - 480)+'px';
    // }
    // const getHeight = ()=>{
    //     if (fullscreen){
    //         return '100vh';
    //     }
    //     return (document.body.clientHeight - 200)+'px';
    // }

    const getIsPin = ()=>{
        return isPin;
    }
    const getData = ()=>{
        return {fileId:fileId,fileName:fileName,filePath:filePath}
    }

    /**
     * 显示或隐藏
     */
    function showOrHidden(){
        if (global.g_isHiddenAllFloatWin){
            setIsVisible(false)
        }else{
            setIsVisible(true)
        }
    }

    const onCloseForPerson = (isUpdate)=>{
        window.closePdfPreview({fileId:fileId||mFileIdRef.current});
        onClose(isUpdate,fileId)
        if (fileId){
            postMessage(EVENT_REFRESH_PDF_HIGHLIGHT,{fileId:fileId||mFileIdRef.current})
        }
    }

    const handleRender = () => {
        const iframe = document.getElementById("pdf-iframe-"+fileId) as HTMLIFrameElement;
        if (iframe) {
            iframe.contentWindow?.postMessage(JSON.stringify({
                path: filePath,
                fileId: fileId,
                type: "open-pdf",
                initialPage:initialPage,
                state:state,
                theme:getTheme(),
                language:getLanguageCode(),
                isReadOnly:global.g_isPresentMode,
                isInDrawRightSlider:isInDraw()
            }), {
                targetOrigin: '*'
            })

            if (initialPage > 1){
                message.success(t("RestoreLastPdfReadPos"))
            }

            if (isViewAllHighlight){
                setTimeout(()=>{
                    iframe.contentWindow?._reader.toggleSidebar(true)
                },100)
            }

            // setTimeout(()=>{
            //     iframe.contentWindow._reader?._updateState({colorScheme: localStorage.getItem(SYS_CONFIG_KEY_THEME)??THEME_LIGHT})
            // },600)

            if (highlightId){
                setTimeout(()=>{
                    iframeRef.current?.contentWindow?.postMessage(JSON.stringify({
                        type: 'highlights-location',
                        id: highlightId,
                        time: 1000
                    }))
                },600)
            }
        }
    }

    const handleDeletePDF = (id: string) => {
        // postMessage(EVENT_DELETE_ELEMENT);
        window.showMessageBox(t("Tips"), t("ConfirmDeleteLibraryItem"), t("Cancel"),t("Confirm"), null,async () => {
            postMessage(EVENT_DELETE_ELEMENT_BY_ID, {id: fileId});
            postMessage(EVENT_DELETE_PDF_FROM_DIALOG,{fileId:fileId});
            //从库中删除
            const library:any = await getCardById(fileId);
            if (library){
                library.isDeleted = 1;
                updateCard(library).then(r=>{
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                    window.globalRefreshList('',{id:fileId})
                })
            }
            onClose(true,fileId)
        });

    }

    const handleDownload = () => {
        const iframe = document.getElementById("pdf-iframe-"+fileId) as HTMLIFrameElement;
        if (iframe) {
            messageApi.loading({
                key: "export-loading",
                type: "loading",
                content: t("Exporting")
            })
            const szFileName = updateName;
            const szData = JSON.stringify({
                isAnnotations: true,
                fileName:szFileName,
                type: "download-pdf"
            });
            iframe.contentWindow?.postMessage(szData, {
                targetOrigin: '*'
            })
        }
    }


    const onClickMenu = ({key}: { key: string }) => {
        switch (key) {
            case "1": {
                // setReNameState({open: true})
                getCardById(fileId)?.then((item:any)=>{
                    if (item){
                        window.showCommonInput(item.name,t("Rename"),"",t("Cancel"),t("Save"),(szContent:string)=>{
                            window.closeCommonInput();
                            item.name = szContent;
                            setUpdateName(szContent);
                            renameCard(item).then(res=>{
                                //更新画布上的....
                                postMessage(EVENT_RENAME_LIBRARY_ITEM,{...item});
                                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                            });
                        });
                    }
                })

                break;
            }
            case "2": {
                handleDownload();
                break;
            }
            case  "delete": {
                handleDeletePDF(fileId)
                break;
            }
            case "4":{
                createCopyLink('library',fileId,'pdf');
                break;
            }
            case "viewAllHighlights":
                const iframe = document.getElementById("pdf-iframe-"+fileId) as HTMLIFrameElement;
                setTimeout(()=>{
                    iframe.contentWindow?._reader.toggleSidebar(true)
                },100)
                break;
            case "showInfo":
                getCardById(fileId)?.then(res=>{
                    window.showInfo('library',res);
                })
                break;
            case "managerTags":
            {
                getCardById(fileId)?.then(res=>{
                    window.showManageTags([res]);
                })
            }
                break;
            case "search":
            {
                const iframe = document.getElementById("pdf-iframe-"+fileId) as HTMLIFrameElement;
                if (iframe) {
                    iframe.contentWindow._reader?.toggleFindPopup({primary: true, open: true})
                }
            }
                break;
            case "copyLink":
                createCopyLink('library',fileId,'pdf');
                break;
            case "addToProject":
                getCardById(fileId).then(res=>{
                    window.showDialogChooseProject([res],res.name)
                })

                break;
        }
    }

    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    const handleMouseDown = (corner) => (e) => {
        mResizing.current = (corner);
        initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        setPointerEvents('none');
        e.preventDefault();
        e.stopPropagation();
    };

    const handleMouseMove = (e) => {
        if (mResizing.current){
            e.stopPropagation();
            setPointerEvents('none');
            setCardItemPointerEvent('none');

            const rect = draggleRef.current.getBoundingClientRect();
            const deltaX = e.clientX - initialMousePos.current.x;
            const deltaY = e.clientY - initialMousePos.current.y;
            let nWidth = 0,nHeight =0;

            switch (mResizing.current) {
                case 'top-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setX(rect.left + deltaX);
                    setY(rect.top + deltaY);
                    break;
                case 'top-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case 'bottom-left':
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    setX(rect.left + deltaX);
                    break;
                case 'bottom-right':
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                case "left":
                    nWidth = (Math.max(rect.width - deltaX, 50));
                    nHeight = rect.height;
                    setX(rect.left + deltaX);
                    break;
                case "top":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height - deltaY, 50));
                    setY(rect.top + deltaY);
                    break;
                case "right":
                    nWidth = (Math.max(rect.width + deltaX, 50));
                    nHeight = rect.height;
                    break;
                case "bottom":
                    nWidth = rect.width;
                    nHeight = (Math.max(rect.height + deltaY, 50));
                    break;
                default:
                    break;
            }

            if (nWidth < 520){
                nWidth = 520;
            }
            if (nHeight < 600){
                nHeight = 600;
            }

            setDialogSize({
                width: nWidth,
                height: nHeight,
                maxHeight: '100vh'
            })

            initialMousePos.current = ({ x: e.clientX, y: e.clientY });
        }

        if (mIsDragging.current) {
            setX(e.clientX - offset.current.x);
            setY(e.clientY - offset.current.y);
        }

    };

    const handleMouseUp = () => {
        mResizing.current = (null);
        setPointerEvents('all');
        setCardItemPointerEvent('all');
    };

// 保存PDF阅读进度
    const savePdfProgress = async (fileId: string, pageNumber: number) => {
        const pdfList = [...arrayPdfs];
        const pdfIndex = pdfList.findIndex(p => p.id === fileId);
        if (pdfIndex !== -1) {
            pdfList[pdfIndex] = {
                ...pdfList[pdfIndex],
                lastReadPage: pageNumber,
                lastReadTime: Date.now()
            };
            setArrayPdfs(pdfList);
            // 更新数据库
            await updatePdf(pdfList[pdfIndex]);
        }
    };

    return (
        <Modal
            keyboard = {!isPin}
            zIndex={zIndex || 2004}
            width={fullscreen ? (size?.width || 0) : dialogSize.width+'px'}
            style={{
                minWidth: fullscreen ? (size?.width || 0) : (dialogSize.width)+'px',
                margin:'0px',
                left:fullscreen ?'0px':x+'px',
                top:fullscreen ?'0px':y+'px',
                paddingBottom:'0px',
                // opacity:isVisible?'1':'0',
                // visibility:isVisible?'visible':'collapse'
                display:isVisible?'':'none'
            }}
            styles={{
                wrapper: {
                    overflow: "hidden",
                    borderRadius: 0,
                    pointerEvents:isPin?'none':'all',
                },
                content: {
                    width: fullscreen ? (size?.width || 0) : (dialogSize.width)+'px',
                    height: fullscreen ? (size?.height || 0) : dialogSize.height + "px",
                    borderRadius: fullscreen ? 0 : 10,

                }
            }}
            title={
                <div style={{display:'flex',flexDirection:'column'}}>
                    {
                        // fullscreen &&
                        // <div style={{margin:'-20px -24px'}}>
                        //     <TitleBar title={''} isDark={false} fromPage={'pdf'}/>
                        // </div>
                    }

                    <StyledContainer style={{/*marginTop: fullscreen ? '30px' : '0px'*/}}>
                        <div className={'flex-row-vertical-center'} style={{background: 'transparent',width:'80%'}}>
                            <img className={'img-16 cursor-pointer'} style={{width: '14px', height: '14px'}}
                                 src={getImagePathWithTheme(fullscreen ? "pdf_exit_full_screen" : "pdf_full_screen")}
                                 onClick={() => {
                                     setFullscreen(!fullscreen);
                                     onFullScreenByWeb(!fullscreen);

                                     const div = document.getElementById('drag-'+fileId);
                                     if (div) {
                                         if (!fullscreen) {
                                             //全屏
                                             dragTransform.current = div.style.transform;
                                             div.style.transform = 'translate(0px, 0px)';
                                         }else {
                                             //还原位置.
                                             div.style.transform = dragTransform.current;
                                         }
                                     }

                                     // onClose(false);
                                     // window.navigate(getPdfPath(),{pdfInfo:{fileId,fileName,filePath,isViewAllHighlight}})
                                 }}
                            ></img>
                            {
                                //右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开右侧栏打开
                                (window.location.href.includes("/draw") || window.location.href.includes("/defaultProject") || window.location.href.includes('/card') || window.location.href.includes('/journal')) &&
                                <img className={'img-16 ml-18 cursor-pointer '}
                                     src={getImagePathWithTheme('dialog_slider_right')} onClick={(event) => {
                                    event.stopPropagation();
                                    onClose(false);
                                    window.closePdfPreview({fileId:fileId})
                                    if (window.location.href.includes("/draw") || window.location.href.includes("/defaultProject")) {
                                        const iframe = document.getElementById("pdf-iframe-"+fileId) as HTMLIFrameElement;
                                        postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                                            pdfPath: filePath,
                                            fileId: fileId,
                                            fileName: updateName,
                                            html: iframe.innerHTML,
                                            pdfFileName: filePath,
                                            breadcrumb:createBreadcrumb("library", fileName)
                                        })
                                    }else {
                                        getCardById(fileId).then((library:any)=>{
                                            window.openRightSlider(library,library.type);
                                        })
                                    }
                                }}/>
                            }
                            <span className={'ml-16 span-single-line'}
                                  style={{
                                      color: 'var(--text-color)',
                                  }}>{updateName}</span>
                        </div>

                        <div className={'flex-row-vertical-center'}>
                            {
                                // isInDraw() &&
                                <Tooltip overlayClassName='font-size-12' title={isPin?t("UnpinFloatWindow"):t("PinAsFloatWindow")} zIndex={9999} arrow={false}>
                                    <img className='img-25 hovered-gray-radius ml-10' onClick={() => {
                                        setTimeout(()=>{
                                            const nPinCount = window.getDialogPinCount();
                                            if (nPinCount > 0){
                                                setHasMaskLayer(false);
                                            }else{
                                                setHasMaskLayer(isPin);
                                            }
                                        },100);
                                        setIsPin(!isPin);
                                    }} src={getImagePathWithTheme(isPin?'dialog_unpin':'dialog_pin')}/>
                                </Tooltip>
                            }


                            <img className={'img-16 ml-12 cursor-pointer'}
                                 src={getImagePathWithTheme('context_menu_info')} onClick={() => {
                                getCardById(fileId)?.then(res => {
                                    window.showInfo('library', res);
                                })
                            }}/>
                            {
                                isShowMoreMenu &&
                                <Dropdown trigger={["click"]} overlayStyle={{minWidth: '168px'}}
                                          align={{offset: [-150, 6]}}
                                          menu={{items: getItems(), onClick: onClickMenu}}>
                                    <img className={'img-15 ml-14 cursor-pointer'}
                                         src={getImagePathWithTheme('vertical_more_gary')}/>
                                </Dropdown>
                            }

                            <img className='img-23 cursor-pointer ml-8 mt-1' onClick={(event)=>{
                                event.stopPropagation();
                                onCloseForPerson(isUpdate);
                                // global.g_showDialogs['dialogPdf'] = false;
                                window.closePdfPreview({fileId:fileId,filePath:filePath});
                                setFullscreen(false);
                                onFullScreenByWeb(false);
                            }}
                                 src={getImagePathWithTheme('icon_pop_close_light.svg')}/>
                        </div>

                    </StyledContainer>
                </div>
            }
            closeIcon={null}
            open={open}
            // centered={true}
            footer={null}
            mask={hasMaskLayer}
            destroyOnClose={true}
            afterOpenChange={(open) => {
                if (open) {
                    handleRender()
                }
            }}
            onClose={() => {
                onCloseForPerson(isUpdate)
            }}
            onCancel={() => {
                if (fullscreen) {
                 // setFullscreen(false);
                }else {
                    onCloseForPerson(isUpdate)
                }
            }}
            modalRender={(modal) => (
                // <Draggable
                //     disabled={false}
                //     // bounds={bounds}
                //     nodeRef={draggleRef}
                //     onMouseDown={(event)=>{
                //         event.stopPropagation();
                //     }}
                //     onStart={(event, uiData) => onStart(event, uiData)}
                // >
                <div className={'div-no-margin'} id={'drag-' + fileId} ref={draggleRef} onMouseDown={(event) => {
                    event.stopPropagation();
                    if (!getIsPin())return;

                    mIsDragging.current = true;
                    offset.current.x = event.clientX - draggleRef.current.getBoundingClientRect().left;
                    offset.current.y = event.clientY - draggleRef.current.getBoundingClientRect().top;
                    setPointerEvents('none');
                }} onMouseMove={(event) => {
                    if (mIsDragging.current) {
                        setX(event.clientX - offset.current.x);
                        setY(event.clientY - offset.current.y);
                    }
                }} onMouseUp={(event) => {
                    mIsDragging.current = false;
                    setPointerEvents('all');
                }} style={{}} onClick={(event) => {
                    event.stopPropagation();
                    window.bringDialogPdfFront({fileId});
                }}>
                    {modal}

                    {/* 四个拖拽手柄 */}
                    {
                        getIsPin() &&
                        <>
                            <div className="resize-handle top-left" onMouseDown={handleMouseDown('top-left')}/>
                            <div className="resize-handle top-right" onMouseDown={handleMouseDown('top-right')}/>
                            <div className="resize-handle bottom-left" onMouseDown={handleMouseDown('bottom-left')}/>
                            <div className="resize-handle bottom-right" onMouseDown={handleMouseDown('bottom-right')}/>
                            <div className="resize-handle left" onMouseDown={handleMouseDown('left')}/>
                            <div className="resize-handle right" onMouseDown={handleMouseDown('right')}/>
                            <div className="resize-handle top" onMouseDown={handleMouseDown('top')}/>
                            <div className="resize-handle bottom" onMouseDown={handleMouseDown('bottom')}/>
                        </>
                    }

                    {/* 你的内容 */}
                </div>
                // </Draggable>
            )}
        >
            {contextHolder}
            <iframe
                ref={iframeRef}
                key={filePath}
                id={"pdf-iframe-" + fileId}
                src={"pdf/reader.html?type=pdf"}
                // src={"http://localhost:3001/dev/reader.html?type=pdf"}
                style={{
                    width: "100%",
                    height: fullscreen ? (size?.height || 0) - 80 : "calc(100% - 22px)",
                    pointerEvents: pointerEvents
                }}
            />
            {/*<RenameModal*/}
            {/*    open={renameState.open}*/}
            {/*    fileName={fileName}*/}
            {/*    fileId={fileId}*/}
            {/*    onClose={(isUpdate, _fileName) => {*/}
            {/*        if (isUpdate) {*/}
            {/*            setUpdateName(_fileName || fileName)*/}
            {/*            setIsUpdate(isUpdate)*/}
            {/*        }*/}
            {/*        setReNameState({*/}
            {/*            open: false*/}
            {/*        })*/}
            {/*    }}*/}
            {/*/>*/}
        </Modal>
    );
});

export default FileModal;
